import PagedResult from "../interfaces/pagedResult";
import User from "../interfaces/user";
import "./ListUserPaged.css";
import UserListItem from "./UserListItem";

interface ListUserPagedProps {
  users: PagedResult<User>;
  currentPage: number;
  pageSize: number;
}

const ListUserPaged = ({
  users,
  currentPage,
  pageSize,
}: ListUserPagedProps) => {
  return (
    <div className="user-list-container">
      <div className="leaderboard-preview">
        <div className="preview-entries">
          {users.items.map((user, index) => (
            <UserListItem
              key={user.id}
              user={user}
              rank={currentPage * pageSize + index + 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListUserPaged;
